var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',{staticClass:"QuizResult"},[_c('h3',[_vm._v(" Score: "+_vm._s(_vm.correct_answer_num)+" / "+_vm._s(_vm.question_num)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }